class HpSubcollections extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('.hp-subcollections__track');
    if (!track || this._initialized) return;

    this._initialized = true;

    const DRAG_SLOP = 10;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let isDragging = false;
    let suppressClick = false;

    const updateOverflow = () => {
      this.classList.toggle('is-overflowing', track.scrollWidth > track.clientWidth + 1);
    };

    updateOverflow();

    track.querySelectorAll('img').forEach((image) => {
      if (!image.complete) {
        image.addEventListener('load', updateOverflow, { once: true });
      }
    });

    const resizeObserver = new ResizeObserver(updateOverflow);
    resizeObserver.observe(track);

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateOverflow, { passive: true });
    }

    track.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;

        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      },
      true
    );

    track.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });

    const endDrag = () => {
      const wasDragging = isDragging;

      if (pointerId !== null && track.hasPointerCapture(pointerId)) {
        track.releasePointerCapture(pointerId);
      }

      pointerId = null;
      this.classList.remove('is-dragging');
      isDragging = false;

      if (!wasDragging) {
        suppressClick = false;
      }
    };

    track.addEventListener('pointerdown', (event) => {
      if (!this.classList.contains('is-overflowing') || event.pointerType === 'touch') return;
      if (event.button !== 0) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = track.scrollLeft;
      isDragging = false;
      suppressClick = false;
    });

    track.addEventListener('pointermove', (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (!isDragging) {
        if (Math.abs(deltaX) < DRAG_SLOP && Math.abs(deltaY) < DRAG_SLOP) return;

        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          pointerId = null;
          return;
        }

        isDragging = true;
        suppressClick = true;
        this.classList.add('is-dragging');
        track.setPointerCapture(pointerId);
      }

      event.preventDefault();
      track.scrollLeft = startScrollLeft - deltaX;
    });

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
  }
}

if (!window.customElements.get('hp-subcollections')) {
  window.customElements.define('hp-subcollections', HpSubcollections);
}
